// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3pVCq","dragIcon":"Choice_dragIcon__M9nNj","left":"Choice_left__1ZJVa","input":"Choice_input__3S40f"};